import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const strDate = control.value;

    if (!strDate) {
      return null;
    }

    const date = new Date(strDate);

    if (date && (date.getFullYear() < 1753 || date.getFullYear() > 9999)) {
      control.setErrors({ dateinvalid: true });
      return { dateinvalid: true };
    } else {
      return null;
    }
  };
}
